import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './Clientes.module.css';

const TRABAJOS = [
  { img: 'bolsa_de_comercio.jpg',            cap: 'Bolsa de Comercio de Buenos Aires' },
  { img: 'Contador de bicicletas (1).jpg',   cap: 'Contador de Bicicletas'           },
  { img: 'Dot-Estacionamiento 4.jpg',         cap: 'Shopping Dot — Estacionamiento'   },
  { img: 'marcha-federal-plaza-de-mayo-36.jpg', cap: 'Plaza de Mayo'                  },
  { img: 'MICROLED - ANDENES LINEA H (1).jpg', cap: 'Andenes Subte Línea H'          },
  { img: 'peajes autopistas del sol.jpg',    cap: 'Peaje Autopista del Sol'          },
  { img: 'TARIDADOR DE PRECIOS YPF.JPG',     cap: 'Tarifador de Precios — YPF'       },
];

const LOGOS = [
  'Aeropuertos Argentina 2000.png',
  'Alto Palermo.png',
  'Axion.png',
  'Banca Francés.png',
  'Banca Provincia.png',
  'Bolsa De Comerio.png',
  'Coca Cola.png',
  'Wolswagen.png',
  'Dot.png',
  'Fiat.png',
  'HSBC.png',
  'La Rural.png',
  'Metrovias.png',
  'Patio Bullrich.png',
  'Puma.png',
  'Renault.png',
  'Santander.png',
  'Ternium.png',
  'Mesa de trabajo 32.png',
  'Mesa de trabajo 36.png',
  'Mesa de trabajo 37.png',
];

export default function Clientes() {
  return (
    <>
      <Helmet>
        <title>• Clientes y Trabajos Realizados — Microled 🔴</title>
        <meta name="description" content="Empresas que confían en Microled Argentina. Trabajos realizados en todo el país: subtes, autopistas, bancos, shoppings, YPF, Puma, Renault y más." />
        <meta property="og:title"       content="Clientes y Proyectos — Microled Argentina" />
        <meta property="og:description" content="Más de 30 años instalando pantallas LED en Argentina. Subtes, autopistas, bancos, shoppings y más." />
        <meta property="og:image"       content="https://microled.com.ar/img/home/tapate_la_boca_linea_h.jpg" />
        <meta name="theme-color"        content="#CB3234" />
        <link rel="canonical"           href="https://microled.com.ar/clientes" />
      </Helmet>

      {/* ── Banner ── */}
      <div
        className={styles.banner}
        style={{ backgroundImage: `url('/img/franjas/franja_formulario.jpg')` }}
      >
        <div className={styles.bannerOverlay} />
        <div className={styles.bannerContent}>
          <p className={styles.bannerPre}>Portfolio</p>
          <h1 className={styles.bannerTitle}>Confiaron en nosotros</h1>
          <p className={styles.bannerSub}>Más de 500 instalaciones en empresas líderes de Argentina</p>
        </div>
      </div>

      {/* ── Trabajos realizados ── */}
      <section className={styles.section}>
        <div className={styles.sectionHead}>
          <span className={styles.pre}>Proyectos</span>
          <h2>Trabajos realizados</h2>
        </div>

        <div
          className={styles.photoGrid}
          data-uk-lightbox="animation: slide"
        >
          {TRABAJOS.map((t, i) => (
            <a
              key={i}
              href={`/img/clientes/realizados_clientes/${t.img}`}
              data-caption={t.cap}
              className={styles.photoItem}
            >
              <img
                src={`/img/clientes/realizados_clientes/${t.img}`}
                alt={t.cap}
                loading="lazy"
              />
              <div className={styles.photoCaption}>
                <span>{t.cap}</span>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* ── Logos clientes ── */}
      <section className={styles.logosSection}>
        <div className={styles.sectionHead}>
          <span className={styles.pre}>Clientes</span>
          <h2>Empresas que nos eligen</h2>
          <p>Desde pymes hasta grandes corporaciones confían en Microled</p>
        </div>

        <div className={styles.logoGrid}>
          {LOGOS.map((logo, i) => (
            <div key={i} className={styles.logoItem}>
              <img
                src={`/img/clientes/logos/${logo}`}
                alt={logo.replace(/\.(png|jpg|jpeg)$/i, '')}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
